export const ADD_FARM_CONTEXT_ACTION_TYPES = {
  SET_NAME: 'set-name',
  SET_LAT: 'set-lat',
  SET_LNG: 'set-lng',
  SET_ZOOM: 'set-zoom',
  SET_BOUNDS: 'set-bounds',
  SET_ZONE: 'set-zone',
  SET_LFD: 'set-lfd',
  SET_FFD: 'set-ffd',
  SET_GDD_5: 'set-gdd-5',
  SET_GDD_10: 'set-gdd-10',
  SET_ABS_MAX_TEMP: 'set-abs-max-temp',
  SET_ABS_MIN_TEMP: 'set-abs-min-temp',
  SET_AVG_MAX_TEMP: 'set-avg-max-temp',
  SET_AVG_MIN_TEMP: 'set-avg-min-temp',
  SET_AVG_DTR: 'set-avg-dtr',
  SET_AVG_FFW: 'set-avg-ffw',
  SET_MIN_FFW: 'set-min-ffw',
  SET_AVG_OPTIMAL_DAYS: 'set-avg-optimal-days',
  SET_AVG_HEAT_DAYS32: 'set-avg-heat-days32',
  SET_AVG_HEAT_DAYS38: 'set-avg-heat-days38',
  SET_AVG_TROP_NIGHTS: 'set-avg-trop-nights',
  SET_AVG_CHILL_DAYS: 'set-avg-chill-days',
  SET_STD_LFD: 'set-std-lfd',
  SET_STD_FFD: 'set-std-ffd',
  SET_FS_RISK: 'set-fs-risk',
  SET_AVG_DAILY_GDD5: 'set-avg-daily-gdd5',
  SET_AVG_DAILY_GDD10: 'set-avg-daily-gdd10',
  SET_CLIMATE_DATA: 'set-climate-data',
  RESET_STATE: 'reset-state',
}

export const initialState = {
  name: null,
  lat: null,
  lng: null,
  zoom: null,
  bounds: null,
  zone: null,
  lfd: null,
  ffd: null,
  gdd5: null,
  gdd10: null,
  absMaxTemp: null,
  absMinTemp: null,
  avgMaxTemp: null,
  avgMinTemp: null,
  avgDtr: null,
  avgFfw: null,
  minFfw: null,
  avgOptimalDays: null,
  avgHeatDays32: null,
  avgHeatDays38: null,
  avgTropNights: null,
  avgChillDays: null,
  stdLfd: null,
  stdFfd: null,
  fsRisk: null,
  avgDailyGdd5: null,
  avgDailyGdd10: null,
  gdd5Series: null,
  gdd10Series: null,
}

export function AddFarmContextReducer(state, action) {
  switch(action.type) {
    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_NAME:
      return {
        ...state,
        name: action.name
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_LAT:
      return {
        ...state,
        lat: action.lat
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_LNG:
      return {
        ...state,
        lng: action.lng
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_ZOOM:
      return {
        ...state,
        zoom: action.zoom
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_BOUNDS:
      return {
        ...state,
        bounds: action.bounds
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_ZONE:
      return {
        ...state,
        zone: action.zone
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_LFD:
      return {
        ...state,
        lfd: action.lfd
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_FFD:
      return {
        ...state,
        ffd: action.ffd
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_GDD_10:
      return {
        ...state,
        gdd10: action.gdd10
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_GDD_5:
      return {
        ...state,
        gdd5: action.gdd5
      }
  
    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_ABS_MIN_TEMP:
      return {
        ...state,
        absMinTemp: action.absMinTemp
      }
  
    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_ABS_MAX_TEMP:
      return {
        ...state,
        absMaxTemp: action.absMaxTemp
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_MIN_TEMP:
      return {
        ...state,
        avgMinTemp: action.avgMinTemp
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_MAX_TEMP:
      return {
        ...state,
        avgMaxTemp: action.avgMaxTemp
      }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_DTR:
      return { ...state, avgDtr: action.avgDtr }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_FFW:
      return { ...state, avgFfw: action.avgFfw }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_MIN_FFW:
      return { ...state, minFfw: action.minFfw }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_OPTIMAL_DAYS:
      return { ...state, avgOptimalDays: action.avgOptimalDays }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_HEAT_DAYS32:
      return { ...state, avgHeatDays32: action.avgHeatDays32 }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_HEAT_DAYS38:
      return { ...state, avgHeatDays38: action.avgHeatDays38 }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_TROP_NIGHTS:
      return { ...state, avgTropNights: action.avgTropNights }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_CHILL_DAYS:
      return { ...state, avgChillDays: action.avgChillDays }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_STD_LFD:
      return { ...state, stdLfd: action.stdLfd }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_STD_FFD:
      return { ...state, stdFfd: action.stdFfd }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_FS_RISK:
      return { ...state, fsRisk: action.fsRisk }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_DAILY_GDD5:
      return { ...state, avgDailyGdd5: action.avgDailyGdd5 }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_DAILY_GDD10:
      return { ...state, avgDailyGdd10: action.avgDailyGdd10 }

    case ADD_FARM_CONTEXT_ACTION_TYPES.SET_CLIMATE_DATA:
      return { ...state, ...action.data }

    case ADD_FARM_CONTEXT_ACTION_TYPES.RESET_STATE:
      return initialState

    default: {
      throw new Error('Unknown action sent to AddFarmContextReducer:', action.type)
    }
  }
}
